// A deadline can move the time, or close bus changes.
// Type "NoBusChange" with a date closes that one date.
// Type "NoBusChange" with no date closes that weekday every week.

const WEEKDAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export function isNoBusChangeDeadline(deadline) {
  if (!deadline) return false;
  const type = String(deadline.type || deadline.Type || "")
    .trim()
    .toLowerCase();
  return type === "nobuschange";
}

export function closedDayMessage(deadline) {
  if (!isNoBusChangeDeadline(deadline)) return null;
  if (deadline.exceptionDate || deadline.ExceptionDate) {
    return "No bus changes on this day.";
  }
  const dayOfWeek = Number(
    deadline.dayOfWeek != null ? deadline.dayOfWeek : deadline.DayOfWeek
  );
  const name = WEEKDAY_NAMES[dayOfWeek];
  return name
    ? "No bus changes on " + name + "s."
    : "No bus changes on this day.";
}

function addDays(dateStr, days) {
  const parts = String(dateStr).slice(0, 10).split("-").map(Number);
  const dt = new Date(parts[0], parts[1] - 1, parts[2] + days);
  const month = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return dt.getFullYear() + "-" + month + "-" + day;
}

// First closed day in the range. A weekday close (no date) matches every week.
export function closedDayInRange(deadlines, startDate, endDate) {
  if (!startDate) return null;
  let cursor = String(startDate).slice(0, 10);
  let end = endDate ? String(endDate).slice(0, 10) : cursor;
  if (end < cursor) end = cursor;
  for (let i = 0; i < 370; i++) {
    const message = closedDayMessage(deadlineForDate(deadlines, cursor));
    if (message) return message;
    if (cursor >= end) break;
    cursor = addDays(cursor, 1);
  }
  return null;
}

export function deadlineForDate(deadlines, dateStr) {
  const list = deadlines || [];
  if (!dateStr) return null;
  const exception = list.find(
    (d) => d.exceptionDate && String(d.exceptionDate).startsWith(dateStr)
  );
  if (exception) return exception;
  const dayOfWeek = new Date(dateStr + "T00:00:00").getDay();
  return (
    list.find(
      (d) => !d.exceptionDate && Number(d.dayOfWeek) === dayOfWeek
    ) || null
  );
}
